import { createAction } from '@reduxjs/toolkit';

export const setPointsLevels = createAction('ui/SET_POINTS_LEVELS');
export const clearPointsLevels = createAction('ui/CLEAR_POINTS_LEVELS');
